import {
    CourseClient
} from '../clients/CourseClient';

export const SidebarStore = {
    state: {
        units: [],
        errors: []
    },

    getters: {},
    mutations: {
        //synchronous
        SET_ERRORS: (state, errors) => {
            state.errors = errors;
        },
        SET_UNITS: (state, courses) => {
            state.units = courses;
        },
    },

    actions: {
        //asynchronous
        GET_UNITS: async ({
            commit
        }) => {
            return CourseClient.getCourses()
                .then(function (res) {
                    commit('SET_UNITS', res.data.courses);
                })
                .catch(function () {});
        }

    },
};